import React from 'react'
import { Observer } from 'mobx-react'
import { Link } from 'react-router-dom'

import StixDataTable from '@softwaredev_cegeka/stix-data-table/dist/components/StixDataTable'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import LinkButton from '@softwaredev_cegeka/stix-core/dist/components/Button/subcomponents/LinkButton'
import DataTableStatusIndicator from '@softwaredev_cegeka/stix-data-table/dist/components/DataTableStatusIndicator'

import NewsStore from '../../stores/NewsStore'
import { authenticatedUserStore } from '../../stores'
import formatDate from '../../utils/utils'
import TooltipOnOverflowContainer from '../TooltipOnOverflowContainer'
// Styles
import styles from './dataTable.module.scss'

function DataTable(props) {
    let data = React.useMemo(() => props.data, [props.data])

    function getTargetAudience(row) {
        let targetAudience = []
        row.organizations.forEach(element => {
            targetAudience.push(element.name)
        })
        if (targetAudience.length > 0) {
            return (
                <TooltipOnOverflowContainer
                    className={'article-table-tooltip'}
                    text={targetAudience.join(', ')}
                />
            )
        }
        return <span>All customers</span>
    }

    return props.data ? (
        <StixDataTable
            className={styles.table}
            {...props}
            variant={'compact'}
            gridTemplate={`min-content repeat(5, 1fr) 2fr 1fr min-content`}
        >
            <StixDataTable.HeaderRow>
                <StixDataTable.Header />
                <StixDataTable.Header>Target audience</StixDataTable.Header>
                <StixDataTable.Header>Author</StixDataTable.Header>
                <StixDataTable.Header>Category</StixDataTable.Header>
                <StixDataTable.Header>Subcategory</StixDataTable.Header>
                <StixDataTable.Header>Posted on</StixDataTable.Header>
                <StixDataTable.Header>Title</StixDataTable.Header>
                <StixDataTable.Header>Type</StixDataTable.Header>
                <StixDataTable.Header />
            </StixDataTable.HeaderRow>
            {data.map((row, index) => {
                return (
                    <StixDataTable.Row key={`news-article-row-${index}`}>
                        <StixDataTable.Cell>
                            <DataTableStatusIndicator
                                variant={NewsStore.STATUS_MAP[row.category]}
                            />
                        </StixDataTable.Cell>
                        <StixDataTable.Cell>
                            {getTargetAudience(row)}
                        </StixDataTable.Cell>
                        <StixDataTable.Cell>
                            {row.author_first_name + ' ' + row.author_last_name}
                        </StixDataTable.Cell>
                        <StixDataTable.Cell>{row.category}</StixDataTable.Cell>
                        <StixDataTable.Cell>
                            {row.subcategory}
                        </StixDataTable.Cell>
                        <StixDataTable.Cell>
                            {formatDate(row.creation_timestamp)}
                        </StixDataTable.Cell>
                        <StixDataTable.Cell>{row.title}</StixDataTable.Cell>
                        <StixDataTable.Cell>{row.type}</StixDataTable.Cell>
                        <StixDataTable.Cell>
                            <Observer>
                                {() => (
                                    <LinkButton
                                        as={Link}
                                        to={`/articles/edit/${row.id}`}
                                        disabled={
                                            !authenticatedUserStore.isAllowed(
                                                'WRITE'
                                            )
                                        }
                                    >
                                        <Icon icon="edit" />
                                    </LinkButton>
                                )}
                            </Observer>
                        </StixDataTable.Cell>
                    </StixDataTable.Row>
                )
            })}
        </StixDataTable>
    ) : (
        {}
    )
}

export default DataTable
